import { useEffect } from 'react';
import type { Configuration, OnError, OnNudge } from './contracts';
import NudgeManager from './NudgeManager';
import type Result from './Result';

declare global {
  interface Merch {
    isModalOpen: boolean;
    mayNudgeShow: (nudgeId: string) => Promise<Result>;
  }

  interface Window {
    merch: Merch;
  }
}

export default function useNudgeManager(
  configuration: Partial<Configuration>,
  isModalOpen: boolean,
  onNudge?: OnNudge,
  onError?: OnError
) {
  useEffect(() => {
    const nudgeManager = new NudgeManager(configuration, onNudge, onError);

    window.merch = {
      ...window.merch,
      mayNudgeShow(nudgeId: string) {
        return nudgeManager.mayNudgeShow(nudgeId);
      }
    };
  }, [configuration, onError, onNudge]);

  useEffect(() => {
    window.merch = { ...window.merch, isModalOpen };
  }, [isModalOpen]);
}
